
import '../styles/app.scss';

window.easings = {};
window.easings.ease = "cubicBezier(0.25, 0.46, 0.45, 0.94)";
window.easings.andrew = "cubicBezier(0.77, 0, 0.175, 1)";
window.easings.feebles1 = "cubicBezier(.8,.03,.25,1)";
window.easings.feebles2 = "cubicBezier(.72,.01,.25,1)";
window.easings.ease2 = "cubicBezier(.48,.1,.48,.9)";

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function(){
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function(){ Breakpoint.refreshValue(); }).resize();

// Fix for passive event listeners. This should be fixed in a future version of jQuery so it can be removed here.
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

// Libs
import PubSub from "pubsub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";

// Components Import -- DO NOT REMOVE COMMENT!
import HeroTakeover from "../components/molecules/Hero/HeroTakeover/HeroTakeover";
import Loader from "../components/molecules/Global/Loader/Loader";
import ContentIntro from "../components/molecules/Content/ContentIntro/ContentIntro";
import ListingFeatures from "../components/molecules/Listing/ListingFeatures/ListingFeatures";
import ListingInfo from "../components/molecules/Listing/ListingInfo/ListingInfo";
import HeroSpotlight from "../components/molecules/Hero/HeroSpotlight/HeroSpotlight";
import ButtonSecondary from "../components/atoms/ButtonSecondary/ButtonSecondary";
import Breadcrumbs from "../components/elements/Global/Breadcrumbs/Breadcrumbs";
import ModalEBrochure from "../components/molecules/Modal/ModalEBrochure/ModalEBrochure";
import ModalFormResponse from "../components/molecules/Modal/ModalFormResponse/ModalFormResponse";
import LayoutFloorPlanDetail from "../components/layouts/LayoutFloorPlanDetail/LayoutFloorPlanDetail";
import FloorPlanListingCard from "../components/elements/FloorPlanListingCard/FloorPlanListingCard";
import ListingFloorPlans from "../components/molecules/Listing/ListingFloorPlans/ListingFloorPlans";
import ListingFaq from "../components/molecules/Listing/ListingFaq/ListingFaq";
import GalleryGridTwoUp from "../components/molecules/Gallery/GalleryGridTwoUp/GalleryGridTwoUp";
import GalleryHighlight from "../components/molecules/Gallery/GalleryHighlight/GalleryHighlight";
import GalleryFullWidth from "../components/molecules/Gallery/GalleryFullWidth/GalleryFullWidth";
import CommunityEngagementQuoteSlider from "../components/molecules/CommunityEngagement/CommunityEngagementQuoteSlider/CommunityEngagementQuoteSlider";
import CommunityEngagementResultsCards from "../components/molecules/CommunityEngagement/CommunityEngagementResultsCards/CommunityEngagementResultsCards";
import CommunityEngagementQuoteCards from "../components/molecules/CommunityEngagement/CommunityEngagementQuoteCards/CommunityEngagementQuoteCards";
import CommunityEngagementResultsList from "../components/molecules/CommunityEngagement/CommunityEngagementResultsList/CommunityEngagementResultsList";
import CommunityEngagementResultsBarGraphs from "../components/molecules/CommunityEngagement/CommunityEngagementResultsBarGraphs/CommunityEngagementResultsBarGraphs";
import CommunityEngagementForm from "../components/molecules/CommunityEngagement/CommunityEngagementForm/CommunityEngagementForm";
import CommunityEngagementIntro from "../components/molecules/CommunityEngagement/CommunityEngagementIntro/CommunityEngagementIntro";
import ModalForm from "../components/molecules/Modal/ModalForm/ModalForm";
import UnitListingCard from "../components/elements/UnitListingCard/UnitListingCard";
import MapFloorPlansWithUnits from "../components/molecules/Map/MapFloorPlansWithUnits/MapFloorPlansWithUnits";
import ListingUnits from "../components/molecules/Listing/ListingUnits/ListingUnits";
import ModalUnitDetail from "../components/molecules/Modal/ModalUnitDetail/ModalUnitDetail";
import MediaGallery from "../components/elements/MediaGallery/MediaGallery";
import LayoutUnitDetail from "../components/layouts/LayoutUnitDetail/LayoutUnitDetail";
import NavBar from "../components/elements/NavBar/NavBar";
import LeasingPopupSlide from "../components/elements/LeasingPopup/LeasingPopupSlide/LeasingPopupSlide";
import LeasingPopup from "../components/molecules/Widgets/LeasingPopup/LeasingPopup";
import FormWithTextContent from "../components/molecules/Form/FormWithTextContent/FormWithTextContent"
import MapProjectMapWithInfoPopups from "../components/molecules/Map/MapProjectMapWithInfoPopups/MapProjectMapWithInfoPopups"
import NavigationPrimary from "../components/atoms/NavigationPrimary/NavigationPrimary"
import MapWithMarkersSimple from "../components/molecules/Map/MapWithMarkersSimple/MapWithMarkersSimple"
import QuoteTallSlider from "../components/molecules/Quote/QuoteTallSlider/QuoteTallSlider"
import FooterSimple from "../components/molecules/Footer/FooterSimple/FooterSimple"
import QuoteShortWithIcon from "../components/molecules/Quote/QuoteShortWithIcon/QuoteShortWithIcon"
import ListingThreeUpImageCards from "../components/molecules/Listing/ListingThreeUpImageCards/ListingThreeUpImageCards"
import ListingThreeUpTextCards from "../components/molecules/Listing/ListingThreeUpTextCards/ListingThreeUpTextCards"
import ListingFiveUpBgImageCardsSlider from "../components/molecules/Listing/ListingFiveUpBgImageCardsSlider/ListingFiveUpBgImageCardsSlider"
import ListingFourUpImageCardsLight from "../components/molecules/Listing/ListingFourUpImageCardsLight/ListingFourUpImageCardsLight"
import ListingFourUpImageCardsDark from "../components/molecules/Listing/ListingFourUpImageCardsDark/ListingFourUpImageCardsDark"
import FormWithBgImage from "../components/molecules/Form/FormWithBgImage/FormWithBgImage"
import CtaFullWidthContent from "../components/molecules/Cta/CtaFullWidthContent/CtaFullWidthContent"
import HeroSimplePageHeading from "../components/molecules/Hero/HeroSimplePageHeading/HeroSimplePageHeading"
import VideoCentered from "../components/molecules/Video/VideoCentered/VideoCentered"
import VideoFullWidth from "../components/molecules/Video/VideoFullWidth/VideoFullWidth"
import GalleryTwoUp from "../components/molecules/Gallery/GalleryTwoUp/GalleryTwoUp"
import GalleryGrid from "../components/molecules/Gallery/GalleryGrid/GalleryGrid"
import ContentImageSlideshow from "../components/molecules/Content/ContentImageSlideshow/ContentImageSlideshow"
import ContentHeadingLeftWithButton from "../components/molecules/Content/ContentHeadingLeftWithButton/ContentHeadingLeftWithButton"
import ContentHeadingWithText from "../components/molecules/Content/ContentHeadingWithText/ContentHeadingWithText"
import ButtonPrimary from "../components/atoms/ButtonPrimary/ButtonPrimary"
import ContentButtonRight from "../components/molecules/Content/ContentButtonRight/ContentButtonRight"
import ContentSidebarLinks from "../components/molecules/Content/ContentSidebarLinks/ContentSidebarLinks"
import HeroBgImage from "../components/molecules/Hero/HeroBgImage/HeroBgImage"
import HeroBgImageSlider from "../components/molecules/Hero/HeroBgImageSlider/HeroBgImageSlider"
import Breadcrumb from "../components/elements/Breadcrumb/Breadcrumb"
import NavOverlay from "../components/molecules/Navigation/NavOverlay/NavOverlay"

document.addEventListener('DOMContentLoaded', function(event) {

	var components = [
		// Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".comp-HeroTakeover", require: HeroTakeover },
{handle: ".comp-Loader", require: Loader },
{handle: ".comp-ContentIntro", require: ContentIntro },
{handle: ".comp-ListingFeatures", require: ListingFeatures },
{handle: ".comp-ListingInfo", require: ListingInfo },
{handle: ".comp-HeroSpotlight", require: HeroSpotlight },
{handle: ".atom-ButtonSecondary", require: ButtonSecondary },
{handle: ".el-Breadcrumbs", require: Breadcrumbs },
{handle: ".comp-ModalEBrochure", require: ModalEBrochure },
{handle: ".comp-ModalFormResponse", require: ModalFormResponse },
{handle: ".layout-LayoutFloorPlanDetail", require: LayoutFloorPlanDetail },
{handle: ".el-FloorPlanListingCard", require: FloorPlanListingCard },
{handle: ".comp-ListingFloorPlans", require: ListingFloorPlans },
{handle: ".comp-ListingFaq", require: ListingFaq },
{handle: ".comp-GalleryGridTwoUp", require: GalleryGridTwoUp },
{handle: ".comp-GalleryHighlight", require: GalleryHighlight },
{handle: ".comp-GalleryFullWidth", require: GalleryFullWidth },
{handle: ".comp-CommunityEngagementQuoteSlider", require: CommunityEngagementQuoteSlider },
{handle: ".comp-CommunityEngagementResultsCards", require: CommunityEngagementResultsCards },
{handle: ".comp-CommunityEngagementQuoteCards", require: CommunityEngagementQuoteCards },
{handle: ".comp-CommunityEngagementResultsList", require: CommunityEngagementResultsList },
{handle: ".comp-CommunityEngagementResultsBarGraphs", require: CommunityEngagementResultsBarGraphs },
{handle: ".comp-CommunityEngagementForm", require: CommunityEngagementForm },
{handle: ".comp-CommunityEngagementIntro", require: CommunityEngagementIntro },
{handle: ".comp-ModalForm", require: ModalForm },
{handle: ".el-UnitListingCard", require: UnitListingCard },
{handle: ".comp-MapFloorPlansWithUnits", require: MapFloorPlansWithUnits },
{handle: ".comp-ListingUnits", require: ListingUnits },
{handle: ".comp-ModalUnitDetail", require: ModalUnitDetail },
{handle: ".el-MediaGallery", require: MediaGallery },
{handle: ".layout-LayoutUnitDetail", require: LayoutUnitDetail },
{handle: ".el-NavBar", require: NavBar },
{handle: ".el-LeasingPopupSlide", require: LeasingPopupSlide },
{handle: ".comp-LeasingPopup", require: LeasingPopup },
{handle: ".comp-FormWithTextContent", require: FormWithTextContent },
{handle: ".comp-MapProjectMapWithInfoPopups", require: MapProjectMapWithInfoPopups },
{handle: ".atom-NavigationPrimary", require: NavigationPrimary },
{handle: ".comp-MapWithMarkersSimple", require: MapWithMarkersSimple },
{handle: ".comp-QuoteTallSlider", require: QuoteTallSlider },
{handle: ".comp-FooterSimple", require: FooterSimple },
{handle: ".comp-QuoteShortWithIcon", require: QuoteShortWithIcon },
{handle: ".comp-ListingThreeUpImageCards", require: ListingThreeUpImageCards },
{handle: ".comp-ListingThreeUpTextCards", require: ListingThreeUpTextCards },
{handle: ".comp-ListingFiveUpBgImageCardsSlider", require: ListingFiveUpBgImageCardsSlider },
{handle: ".comp-ListingFourUpImageCardsLight", require: ListingFourUpImageCardsLight },
{handle: ".comp-ListingFourUpImageCardsDark", require: ListingFourUpImageCardsDark },
{handle: ".comp-FormWithBgImage", require: FormWithBgImage },
{handle: ".comp-CtaFullWidthContent", require: CtaFullWidthContent },
{handle: ".comp-HeroSimplePageHeading", require: HeroSimplePageHeading },
{handle: ".comp-VideoCentered", require: VideoCentered },
{handle: ".comp-VideoFullWidth", require: VideoFullWidth },
{handle: ".comp-GalleryTwoUp", require: GalleryTwoUp },
{handle: ".comp-GalleryGrid", require: GalleryGrid },
{handle: ".comp-ContentImageSlideshow", require: ContentImageSlideshow },
{handle: ".comp-ContentHeadingLeftWithButton", require: ContentHeadingLeftWithButton },
{handle: ".comp-ContentHeadingWithText", require: ContentHeadingWithText },
{handle: ".atom-ButtonPrimary", require: ButtonPrimary },
{handle: ".comp-ContentButtonRight", require: ContentButtonRight },
{handle: ".comp-ContentSidebarLinks", require: ContentSidebarLinks },
{handle: ".comp-HeroBgImage", require: HeroBgImage },
{handle: ".comp-HeroBgImageSlider", require: HeroBgImageSlider },
{handle: ".el-Breadcrumb", require: Breadcrumb },
{handle: ".comp-NavOverlay", require: NavOverlay },
	];

	window.sitewide = new Sitewide();
	window.sitewide.init();

	// Getting our components loading going
	var componentsLoader = new ComponentsLoader({components: components});
	componentsLoader.initScreen();

	// setting our breakpoint value
	Breakpoint.refreshValue();

});
